import Image from "next/image";
import Icon from "@/components/icons";
import { cn } from "@/lib/utils";

import styles from "./index.module.css";
import icon from "@/public/icons/testimonial-icon.svg";

type Props = {
  id: string;
  attribution: string;
  program?: string;
  children?: React.ReactNode;
  showQuote?: boolean;
  className?: string;
};

export default function TestimonialLight({
  id,
  attribution,
  program,
  children,
  showQuote = false,
  className,
}: Props) {
  return (
    <div
      key={id}
      className={cn(
        "test rounded-xl flex flex-col basis-0 grow shrink justify-between w-full lg:w-auto lg:max-w-[400px] p-6",
        className,
      )}
    >
      <div className="flex items-start gap-5">
        {showQuote && (
          <div className="flex-shrink-0">
            <Icon
              type="format-quote"
              svgProps={{
                width: 32,
                height: 32,
                className: "text-brand-500 scale-x-[-1] flex-shrink-0",
              }}
            />
          </div>
        )}
        <div className={styles.content}>{children}</div>
      </div>

      <div className="flex shrink-0 items-start border-t pt-6 gap-6">
        <div className="flex shrink-0">
          <Image src={icon} height={67} width={67} alt="" className="m-0" />
        </div>
        <div
          className={`flex flex-col ${!program ? "justify-center" : "justify-start"} min-h-[67px]`}
        >
          <p className="font-bold m-0">{attribution}</p>
          {program && <p className="m-0">{program}</p>}
        </div>
      </div>
    </div>
  );
}
